import { COLORS } from '@bcm/constants';

export const defaultPadding = 10;
export const defaultMargin = 10;
export const defaultBorder = 10;
export const pfpDiameters = {
	sm: 45,
	md: 84,
	lg: 120,
	xl: 160,
};

const commonStyles = {
	screen: {
		flex: 1,
	},
	containers: {
		center: {
			flex: 1,
			justifyContent: 'center',
			alignItems: 'center',
		},
		row: {
			flexDirection: 'row',
		},
	},
	shadow: {
		borderRadius: defaultBorder,
		shadowColor: COLORS.black,
		shadowOpacity: 0.26,
		shadowOffset: { width: 0, height: 4 },
		shadowRadius: defaultBorder,
		elevation: 5,
	},
	shadowBottom: {
		shadowColor: COLORS.black,
		shadowOpacity: 0.26,
		shadowOffset: { width: 0, height: 4 },
		elevation: defaultBorder,
	},
	composite: {
		container: {
			flex: 1,
			flexDirection: 'row',
		},
		sidebar: {
			flex: 0.33,
			flexDirection: 'column',
			backgroundColor: COLORS.light,
			borderRightWidth: 2,
			borderRightColor: COLORS.medium,
		},
		mainContentContainer: {
			flex: 0.67,
			backgroundColor: COLORS.light
		},
		stack: {
			flex: 0.5
		}
	},
	zeroDimensions: {
		width: 0,
		height: 0,
		display: 'none',
	}
};

export default commonStyles;